import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { EffectCoverflow } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const packList = [
  {
    id: 'loft-blue',
    url: getImageFromS3('images/sms-lm-loft/loft-blue-pack-kv.png')
  },
  {
    id: 'loft-sea',
    url: getImageFromS3('images/sms-lm-loft/loft-sea-pack-kv.png')
  },
  {
    id: 'loft-purple',
    url: getImageFromS3('images/sms-lm-loft/loft-purple-pack-kv.png')
  }
];

const HomeScreen = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          className={styles.background}
          src={getImageFromS3('images/sms-lm-loft/kv-background.png')}
          alt="head-bg"
        />
        <img
          className={styles.headLogo}
          src={getImageFromS3('images/sms-lm-loft/head-logo.png')}
          alt="head-logo"
        />
        <div className={styles.carousel}>
          <Swiper
            slidesPerView={2}
            spaceBetween={20}
            centeredSlides={true}
            pagination={{
              clickable: true
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
              scale: 0.8 // масштаб неактивних слайдів
            }}
            modules={[EffectCoverflow]}
            className="mySwiper"
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          >
            <div>
              {packList?.map((item, index) => {
                return (
                  <SwiperSlide
                    className={
                      index === activeIndex
                        ? styles.activeSlide
                        : styles.inactiveSlide
                    }
                  >
                    <img
                      src={item?.url}
                      alt={item?.id}
                      className={styles.packItem}
                    />
                  </SwiperSlide>
                );
              })}
            </div>
          </Swiper>
        </div>
        <div className={styles.characteristicContainer}>
          <img
            src={getImageFromS3('images/sms-lm-loft/filter.png')}
            alt="filter"
          />
          <img
            src={getImageFromS3('images/sms-lm-loft/format.png')}
            alt="format"
          />
          <img
            src={getImageFromS3('images/sms-lm-loft/tobacco.png')}
            alt="tobacco"
          />
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
